import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_form = _resolveComponent("v-form")

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(_ctx.submitForm, ["prevent"]),
    ref: "form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_text_field, {
        type: "password",
        variant: "outlined",
        "validate-on-blur": "",
        label: _ctx.passwordData.label,
        placeholder: "Your password",
        rules: _ctx.passwordRules,
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.password) = $event))
      }, null, 8, ["label", "rules", "modelValue"]),
      _createVNode(_component_v_text_field, {
        type: "password",
        variant: "outlined",
        "validate-on-blur": "",
        label: _ctx.repeatPasswordData.label,
        placeholder: "Confirm your password",
        rules: _ctx.repeatPasswordRules,
        modelValue: _ctx.passwordConfirm,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.passwordConfirm) = $event))
      }, null, 8, ["label", "rules", "modelValue"]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["onSubmit"]))
}